import {
  deleteV1DealerIdBorrowerBorIdAddressAddId,
  getV1DealerIdApplicationAppIdCurrentAddress,
  getV1DealerIdBorrowerBorIdAddresses,
  postV1DealerIdBorrowerBorIdAddress,
  putV1DealerIdBorrowerBorIdAddressAddId,
  type DtoAddress,
  type DtoCreateAddressReq,
  type DtoCreateBorrowerAddressResp,
  type DtoGetBorrowersAddressesResp,
} from "@porchpass/api-client";
import {
  assertApiSuccess,
  assertApiSuccessNoContent,
} from "../utils/assertApiSuccess";
import { EMPTY_REQUEST_BODY } from "./constants";
import {
  requireApplicationId,
  requireBorrowerId,
  lazyDealerId,
  type DomainIds,
} from "./types";

export function createAddressDomain(ids: DomainIds) {
  const getDealerId = lazyDealerId(ids);

  return {
    getAddresses: async (
      borrowerId?: string,
    ): Promise<DtoGetBorrowersAddressesResp> => {
      const borId = requireBorrowerId(borrowerId ?? ids.borrowerId);
      const response = await getV1DealerIdBorrowerBorIdAddresses(
        getDealerId(),
        borId,
        EMPTY_REQUEST_BODY,
      );
      return assertApiSuccess<DtoGetBorrowersAddressesResp>(response);
    },

    getCurrentAddress: async (applicationId?: string): Promise<DtoAddress> => {
      const appId = requireApplicationId(applicationId ?? ids.applicationId);
      const response = await getV1DealerIdApplicationAppIdCurrentAddress(
        getDealerId(),
        appId,
        EMPTY_REQUEST_BODY,
      );
      return assertApiSuccess<DtoAddress>(response);
    },

    createAddress: async (
      body: DtoCreateAddressReq,
      borrowerId?: string,
    ): Promise<DtoCreateBorrowerAddressResp> => {
      const borId = requireBorrowerId(borrowerId ?? ids.borrowerId);
      const response = await postV1DealerIdBorrowerBorIdAddress(
        getDealerId(),
        borId,
        body,
      );
      return assertApiSuccess<DtoCreateBorrowerAddressResp>(response);
    },

    updateAddress: async (
      addressId: string,
      body: DtoCreateAddressReq,
      borrowerId?: string,
    ): Promise<DtoCreateBorrowerAddressResp> => {
      const borId = requireBorrowerId(borrowerId ?? ids.borrowerId);
      const response = await putV1DealerIdBorrowerBorIdAddressAddId(
        getDealerId(),
        borId,
        addressId,
        body,
      );
      return assertApiSuccess<DtoCreateBorrowerAddressResp>(response);
    },

    deleteAddress: async (addressId: string, borrowerId?: string) => {
      const borId = requireBorrowerId(borrowerId ?? ids.borrowerId);
      const response = await deleteV1DealerIdBorrowerBorIdAddressAddId(
        getDealerId(),
        borId,
        addressId,
        EMPTY_REQUEST_BODY,
      );
      assertApiSuccessNoContent(response);
    },
  };
}
